import axios from "axios";

export async function fetchSiksinMenusByBusinessNumber(storeBusinessNumber) {
  const sbn = String(storeBusinessNumber || "").trim();
  if (!sbn) return [];

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_FASTAPI_ADS_URL}/stores/by-business/${encodeURIComponent(
        sbn
      )}/siksin/menus`,
      { timeout: 8000 }
    );

    const menus = res?.data?.menus;
    return Array.isArray(menus) ? menus.filter((v) => typeof v === "string" && v.trim()) : [];
  } catch {
    return [];
  }
}

export async function fetchSiksinMenus(localStoreId) {
  if (!localStoreId) return [];

  try {
    const res = await axios.get(
      `${process.env.REACT_APP_FASTAPI_ADS_URL}/stores/${localStoreId}/siksin/menus`,
      { timeout: 8000 }
    );

    const menus = res?.data?.menus;
    return Array.isArray(menus) ? menus.filter((v) => typeof v === "string" && v.trim()) : [];
  } catch {
    return [];
  }
}
